export const settings = {
  dots: true,
  infinite: true,
  autoplay: false,
  autoplaySpeed: 4000,
  pauseOnHover: true,
  speed: 1000,
  slidesToShow: 5.5,
  swipeToSlide: true,
  slidesToScroll: 2,
  arrows: false,
  initialSlide: 0,
  // dotsClass: "react-slick__custom-dots",
  responsive: [
    {
      breakpoint: 1640,
      settings: {
        slidesToShow: 4.5,
      },
    },
    {
      breakpoint: 1420,
      settings: {
        slidesToShow: 3.5,
      },
    },
    {
      breakpoint: 1240,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 980,
      settings: {
        slidesToShow: 2.5,
      },
    },
    {
      breakpoint: 500,
      settings: {
        slidesToShow: 1.5,
        centerMode: true,
        className: "center-carousel",
      },
    },
    {
      breakpoint: 390,
      settings: {
        slidesToShow: 1.1,
        centerMode: true,
        className: "center-carousel",
      },
    },
  ],
};
